/* global PhotoSwipe, PhotoSwipeUI_Default, Image */
var angular = require('angular');
angular.module('promemoria').component('auiGallery', {
  template: require('./gallery.html'),
  bindings: {
    images: '<'
  },
  controller: function () {
    var ctrl = this;

    ctrl.onOpen = function (inx) {
      var options = {
        preload: [1, 3],
        tapToClose: false,
        clickToCloseNonZoomable: false,
        closeOnVerticalDrag: false
      };
      options.index = parseInt(inx, 10);
      if (isNaN(options.index)) {
        return;
      }

      var gallery = new PhotoSwipe(ctrl.pswpContainer, PhotoSwipeUI_Default,
                                      ctrl.items, options);

      gallery.listen('gettingData', function (index, item) {
        var url = '';
        var img = '';
        if (typeof item.html === 'undefined' &&
            typeof item.onloading === 'undefined' &&
            (item.w < 1 || item.h < 1)) {
          switch (item.mimetype.split('/')[0]) {
            case 'image':
              img = new Image();
              img.onload = function (e) {
                item.w = this.width;
                item.h = this.height;
                gallery.invalidateCurrItems();
                gallery.updateSize(true);
              };
              img.src = item.src;

              break;
            case 'video':
              url = item.original;
              delete item.src;
              item.html = '<div class="container embed-responsive embed-responsive-archiui" ><video class="embed-responsive-item" controls><source src="' + url + '" type="video/mp4"></source><source src="' + url + '" type="video/ogg"></source>Il tuo browser non supporta la riproduzione video</video></div>';
              gallery.invalidateCurrItems();
              gallery.updateSize(true);
              break;
            case 'audio':
              url = item.original;
              delete item.src;
              item.html = '<div style="position:absolute;top: 50%;left: 50%;transform: translate(-50%,-50%);"><audio controls><source src="' + url + '" type="audio/mpeg"></source><source src="' + url + '" type="audio/ogg"></source>Il tuo browser non supporta la riproduzione audio</audio></div>';
              gallery.invalidateCurrItems();
              gallery.updateSize(true);
              break;
            case 'application':
              url = item.original;
              img = new Image();
              img.onload = function (e) {
                item.w = this.width;
                item.h = this.height;
                gallery.invalidateCurrItems();
                gallery.updateSize(true);
              };
              img.src = item.src;

              if (item.title.indexOf('_blank') < 0) {
                item.title = item.title + ' <a href="' + url + '" target="_blank">Download PDF</a>';
              }

              break;
            default:
              break;
          }

          item.loading = true;
        }
      });

      gallery.init();
    };

    ctrl.$onInit = function () {
      ctrl.pswpContainer = document.querySelectorAll('.pswp')[0];
    };

    ctrl.$onChanges = function (changeObj) {
      if (typeof changeObj.images.currentValue !== 'undefined') {
        var allimg = [];
        ctrl.items = changeObj.images.currentValue.map(function (img, i) {
          img.pid = i;
          return {
            src: img.url.page,
            msrc: img.url.thumbnail,
            title: img.title,
            h: 0, w: 0,
            pid: i,
            mimetype: img.mimetype,
            original: img.url.original
          };
        });

        ctrl.mediaicons = {};

        changeObj.images.currentValue.forEach(function (value, key) {
          var use = value.mimetype.split('/')[0];
          if (hasOwnProperty.call(ctrl.mediaicons, use)) {
            ++ctrl.mediaicons[use];
          } else {
            ctrl.mediaicons[use] = 1;
          }
        });

        ctrl.icon_map = {'image': 'glyphicon-picture',
                        'application': 'glyphicon-file',
                        'audio': 'glyphicon-volume-up ',
                        'video': 'glyphicon-film'};

        for (var i = 0; i < changeObj.images.currentValue.length; i++) {
          if (changeObj.images.currentValue[i].isPrimary) {
            ctrl.primary = changeObj.images.currentValue[i];
          } else {
            allimg.push(changeObj.images.currentValue[i]);
          }
        }

        if (typeof ctrl.primary === 'undefined') {
          ctrl.primary = allimg[0];
        }

        ctrl.images = allimg;
      }
    };
  }
});



// WEBPACK FOOTER //
// ./src/js/components/gallery/gallery.js